import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { RestService } from './lib/RestService';

export class Hashtag {
  _id: string;
  code: string;
  name: string;
  active?: boolean;
  href?: string;
}

@Injectable()
export class HashtagsService extends RestService {

  private apiUrl = `${environment.apiUrl}target/Tag`;

  constructor(private http: HttpClient) {
    super();
  }

  get(): Promise<Hashtag[] | any> {
    return this.http.get<Hashtag[]>(this.apiUrl, { withCredentials: true })
      .toPromise()
      .catch(this.handleError);
  }
}
